<template>
    <v-card v-if="isLoading">
        <div class="text-center my-2" v-if="isLoading">
            <v-progress-circular indeterminate></v-progress-circular>
        </div>
    </v-card>
    <v-card>
        <v-table v-if="!isLoading">
            <tbody>
                <tr v-if="!tegevused || tegevused.length === 0">
                    <td class="py-4">
                        <p class="text-center my-2">
                            Ei ole planeeritud kohtumisi ega tegevusi.
                        </p>
                    </td>
                </tr>
                <tr v-for="tegevus in tegevused" :key="tegevus.id">
                    <td class="py-4 ikooniVeerg">
                        <v-avatar class="rounded mt-4" rounded="0" :color="ikooniVarv(tegevus.liik)">
                            <v-icon size="x-large" color="var(--varv-icon-4)" :icon="ikoon(tegevus.liik)"></v-icon>
                        </v-avatar>
                    </td>
                    <td class="py-4 pealkiriVeerg">
                        <p v-if="tegevus.liik === tegevuseLiigid.HoiveProgramm" class="font-weight-bold text-no-wrap">{{
        tegevus.pealkiri }}</p>
                        <p v-else class="font-weight-bold text-no-wrap text-capitalize-first-letter">{{ tegevus.pealkiri
                            }}</p>
                        <p class="text-medium-emphasis"><b>{{ tegevuseAjaPealkiri(tegevus.liik) }}: </b>{{
        tegevuseAegFormateeritud(tegevus.liik, tegevus.algusKp, tegevus.loppKp) }}</p>
                        <p v-if="tegevus.koht" class="text-medium-emphasis"><b>Koht: </b>{{ tegevus.koht }}</p>
                    </td>
                    <td class="py-4">
                        <div v-if="tegevus.selgitused && tegevus.selgitused.length > 0">
                            <p><b>{{ selgitusePealkiri(tegevus.liik) }}</b></p>
                            <p v-for="selgitus, index in tegevus.selgitused" :key="index">{{ selgitus }}</p>
                        </div>
                    </td>
                    <td class="nuppudeVeerg">
                        <v-btn v-if="tegevus.liik === tegevuseLiigid.ÜldkasulikTöö" color="primary" elevation="3"
                            variant="plain"
                            :to="{ name: 'uldkasulik_Too', params: { ajakavaRidaId: tegevus.lisand?.split('|') } }">
                            Näita ajakava <v-icon icon="mdi-arrow-right"></v-icon>
                        </v-btn>
                        <v-btn v-if="tegevus.liik === tegevuseLiigid.ElektroonilineValve" color="primary" elevation="3"
                            variant="plain"
                            :to="{ name: 'elektrooniline_valve', params: { ajakavaRidaId: tegevus.lisand } }">
                            Näita ajakava <v-icon icon="mdi-arrow-right"></v-icon>
                        </v-btn>
                        <v-btn v-if="tegevus.liik === tegevuseLiigid.ElektroonilineValveKinnitamata" color="primary"
                            elevation="3" variant="plain"
                            :to="{ name: 'elektrooniline_valve', params: { ajakavaRidaId: tegevus.id } }">
                            Näita ajakava <v-icon icon="mdi-arrow-right"></v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
        </v-table>
    </v-card>
</template>

<style scoped>
.ikooniVeerg {
    width: 70px;
}

.nuppudeVeerg {
    width: 170px;
}

.pealkiriVeerg {
    width: 370px;
}

.text-capitalize-first-letter {
    text-transform: lowercase;
}

.text-capitalize-first-letter::first-letter {
    text-transform: uppercase;
}

td {
    vertical-align: text-top !important;
    border-bottom: none !important;
}

.v-list-item__append {
    width: 50%;
    max-width: 50%;
    min-width: 50%;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import moment from 'moment';
import { KohtumineTegevus, TegevuseLiik } from '@/models/KohtumineTegevus';
import { KohtumisedTegevusedTeenus } from '@/core/kohtumised-tegevused-teenus';
import mixin from '@/core/mixins';
import KohtumisedTegevusedMixins from '@/core/kohtumised-tegevused-mixins';

const _kohtumisedTegevusedTeenus = new KohtumisedTegevusedTeenus();

export default defineComponent({
    name: 'PlaneeritudKohtumisedTegevused',
    data() {
        return {

            tegevused: new Array<KohtumineTegevus>(),
            moment: moment,
            isLoading: false,
            tegevuseLiigid: TegevuseLiik
        }
    },
    mixins: [mixin, KohtumisedTegevusedMixins],
    methods: {
        minuKohtumisedTegevused() {
            this.isLoading = true;
            _kohtumisedTegevusedTeenus.minuKohtumisedTegevused().then((tegevused) => {
                this.tegevused = tegevused;
            }).finally(() => {
                this.isLoading = false;
            });
        }
    },
    created() {
        this.moment = moment
    },
    mounted() {
        this.minuKohtumisedTegevused();
    }
});
</script>
